import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import GarmentRow from './GarmentRow';
import * as FiIcons from 'react-icons/fi';

const { FiAlertCircle, FiChevronDown, FiChevronUp } = FiIcons;

const ResultCard = ({ item, incidentCount, isExpanded, onToggle, index }) => {
  const displayOwner = item.owner || 'Sin propietario';
  const groupName = item.metadata?.GroupName || item.garments?.[0]?.metadata?.GroupName;

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }} 
      animate={{ opacity: 1, y: 0 }} 
      transition={{ delay: index * 0.05 }} 
      className="bg-white rounded-xl p-4 shadow-sm border border-gray-100"
    >
      <div className="space-y-3" onClick={onToggle}>
        <div className="flex items-center justify-between cursor-pointer">
          <h3 className="font-bold text-gray-800 text-base uppercase truncate pr-2">
            {displayOwner}
          </h3>
          {incidentCount > 0 && (
            <div className="flex items-center space-x-1 bg-red-100 px-2 py-1 rounded-full shrink-0">
              <SafeIcon icon={FiAlertCircle} className="text-xs text-red-600" />
              <span className="text-xs text-red-600 font-bold">{incidentCount}</span>
            </div>
          )}
        </div>

        <div className="grid grid-cols-3 gap-2 text-center text-xs">
          {[
            { label: 'Nº EMP', value: item.employeeCode },
            { label: 'VEST', value: item.wardrobeName },
            { label: 'TAQ', value: item.locker }
          ].map((stat, idx) => (
            <div key={idx} className="flex flex-col bg-gray-50 rounded p-1">
              <span className="text-[10px] text-gray-400 font-bold uppercase">{stat.label}</span>
              <span className="font-bold text-gray-700">{stat.value}</span>
            </div>
          ))}
        </div>

        <div className="flex justify-center">
          <button className="text-xs text-red-500 font-medium flex items-center gap-1">
            {isExpanded ? 'Ocultar detalles' : `Ver prendas (${item.garments?.length || 0})`}
            <SafeIcon icon={isExpanded ? FiChevronUp : FiChevronDown} />
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isExpanded && (
          <motion.div 
            initial={{ opacity: 0, height: 0 }} 
            animate={{ opacity: 1, height: 'auto' }} 
            exit={{ opacity: 0, height: 0 }} 
            className="overflow-hidden"
          >
            <div className="pt-4 border-t border-gray-100 mt-3 space-y-4">
              {groupName && (
                <div className="bg-slate-100 text-slate-600 px-3 py-1.5 rounded text-xs font-bold uppercase text-center">
                  GRUPO: {groupName}
                </div>
              )}
              <div className="space-y-2">
                {item.garments?.length > 0 ? (
                  item.garments.map((g, idx) => <GarmentRow key={idx} garment={g} />)
                ) : (
                  <p className="text-center text-xs text-gray-400 italic py-2">No hay prendas asignadas.</p>
                )}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default ResultCard;